import axios from '@axios'
import store from '@/store'

// eslint-disable-next-line import/prefer-default-export
export function ServiceSpecialists() {
  this.getSpecialistsAll = () => new Promise((resolve, reject) => {
    axios.get('specialists/getSpecialistsAll')
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.specialists = async filtro => new Promise((resolve, reject) => {
    axios.get('specialists/specialists', { params: filtro })
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        // console.log('err', err)
        const errorMessage = err.response?.data?.message || 'Error fetching specialists data'
        reject({ error: errorMessage, originalError: err })
      })
  })

  this.createSpecialists = data => new Promise(async (resolve, reject) => {
    await axios.post('specialists/createSpecialists', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then(resp => {
      resolve(resp)
    })
      .catch(err => {
        reject(err)
      })
  })

  this.getSpecialistsById = id => new Promise((resolve, reject) => {
    store.commit('SET_LOADING', true)
    axios.get(`specialists/getSpecialistsById/${id}`)
      .then(resp => {
        store.commit('SET_LOCAL_ATENDIMENTO', resp.data)
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
      .finally(() => {
        store.commit('SET_LOADING', false)
      })
  })

  this.getSpecialistsByUuId = uuid => new Promise((resolve, reject) => {
    axios.get(`specialists/getSpecialistsByUuid/${uuid}`)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.updateSpecialists = data => new Promise(async (resolve, reject) => {
    await axios.put('specialists/updateSpecialists', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then(resp => {
      resolve(resp)
    })
      .catch(err => {
        reject(err)
      })
  })

  this.updateStatus = (id, data) => new Promise(async (resolve, reject) => {
    await axios.put(`specialists/updateStatus/${id}`, data).then(resp => {
      resolve(resp)
    })
      .catch(err => {
        reject(err)
      })
  })

  this.deleteSpecialists = id => new Promise((resolve, reject) => {
    axios.delete(`specialists/deleteSpecialists/${id}`)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.updateSpecialistsStatus = (id, data) => new Promise((resolve, reject) => {
    axios.put(`specialists/updateSpecialistsStatus/${id}`, data)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.specialistsId = id => new Promise((resolve, reject) => {
    axios.get(`specialists/specialists/${id}`)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.localAtendimento = id => new Promise((resolve, reject) => {
    axios.get(`specialists/localAtendimento/${id}`)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.statusSpecialist = id => new Promise((resolve, reject) => {
    try {
      axios.get(`specialists/status/${id}`)
        .then(resp => {
          resolve(resp.data)
        })
    } catch (error) {
      reject(error)
    }
  })

  /* Chat */

  this.contacts = async query => new Promise((resolve, reject) => {
    axios.get('specialists/contacts', { params: query })
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.getChatMessages = async chatId => new Promise((resolve, reject) => {
    axios.get(`specialists/chats/${chatId}/messages`)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.markMessagesAsRead = async (chatId, userId) => new Promise((resolve, reject) => {
    axios.put(`specialists/chats/${chatId}/is_read`, { userId })
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.sendMessage = async (chatId, message) => new Promise((resolve, reject) => {
    axios.post(`specialists/chats/${chatId}/messages`, message)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
